// extracted by mini-css-extract-plugin
export var emptyState = "_5c-d";
export var statCard = "_5c-c";
export var table = "_5c-0";
export var tableCell = "_5c-4";
export var tableCellClickable = "_5c-5 _5c-4";
export var tableCellDefault = "_5c-6 _5c-4";
export var tableCellEmpty = "_5c-8";
export var tableCellWithValue = "_5c-7";
export var tableContainer = "_5c-e";
export var tableHeaderWeight = "_5c-1";
export var tableHeaderZone = "_5c-2";
export var tableRowHeader = "_5c-3";
export var viewModeButton = "_5c-9";
export var viewModeButtonActive = "_5c-a _5c-9";
export var viewModeButtonInactive = "_5c-b _5c-9";